(function () {
  'use strict';

  var config = window.SoulyshineStandingDogMap;
  if (!config || !config.images) return;

  var silverMaterials = new Set(config.silverMaterials || []);
  var scheduled = false;

  function updateCartImages(root) {
    (root || document).querySelectorAll('[data-soulyshine-standing-dog-cart-item]').forEach(function (item) {
      var breed = item.getAttribute('data-soulyshine-breed');
      var material = item.getAttribute('data-soulyshine-material');
      var images = config.images[breed];
      if (!images || !material) return;

      var url = silverMaterials.has(material) ? images.silver : images.gold;
      var image = item.querySelector('[data-soulyshine-standing-dog-cart-image]');
      if (!url || !image || image.getAttribute('src') === url) return;

      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.setAttribute('src', url);
      image.setAttribute('alt', breed + ' — ' + material);
      image.setAttribute('data-soulyshine-cart-image-resolved', 'true');
    });
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      updateCartImages(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleUpdate, { once: true });
  } else {
    scheduleUpdate();
  }

  document.addEventListener('cartUpdate', scheduleUpdate);
  document.addEventListener('soulyshine:cart:updated', scheduleUpdate);
  new MutationObserver(scheduleUpdate).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
